import { OtoIndividualTripStepsActions } from '../../lib/types/models/enrollment/oto-individual-trip-steps'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// Whether the caller may still record the voyage individuel: the backend closes it once the stay
// stops being an accueil-transfert one, or once the registration is cancelled.
export function getOtoIndividualTripStepsActions(enrollmentId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getOtoIndividualTripStepsActions.url, { id: enrollmentId })
    )
    .get<OtoIndividualTripStepsActions>()
}
